import { render, staticRenderFns } from "./CustomerInactiveReport.vue?vue&type=template&id=72e5f214&"
import script from "./CustomerInactiveReport.vue?vue&type=script&lang=js&"
export * from "./CustomerInactiveReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports